export default __webpack_public_path__ + "static/media/pec3.59b73349.jpg";